import { render } from "./LinkedinSharing.vue?vue&type=template&id=40afd2f6"
import script from "./LinkedinSharing.vue?vue&type=script&lang=ts"
export * from "./LinkedinSharing.vue?vue&type=script&lang=ts"
script.render = render

export default script